import React from 'react'
import classNames from 'classnames'
import { Else, If, Then } from 'react-if'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { EmptyCircleIcon } from '@/atoms/Icons/EmptyCircleIcon'
import { IconColor } from '@/atoms/utils'

interface CheckedItemProps {
  earned: boolean
  name: string
  checkColor?: IconColor
  checkBackgroundColor?: IconColor
  textClassName?: string
}

export const CheckedItem: React.FC<CheckedItemProps> = ({
  earned,
  name,
  checkBackgroundColor = 'oxide',
  checkColor = 'white',
  textClassName,
}) => {
  return (
    <div data-testid={earned ? 'earned-item' : 'unearned-item'} className="flex items-center">
      <div className="mr-2">
        <If condition={earned}>
          <Then>
            <CircleCheckIcon color1={checkBackgroundColor} color2={checkColor} />
          </Then>
          <Else>
            <EmptyCircleIcon />
          </Else>
        </If>
      </div>
      <div className={classNames(`py-2 ${earned ? '' : 'text-gray-600'}`, textClassName)}>{name}</div>
    </div>
  )
}
